export const saveState = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error("LocalStorage Save Error:", err);
  }
};

export const loadState = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (err) {
    console.error("LocalStorage Load Error:", err);
    return null;
  }
};

export const clearState = (key) => {
  localStorage.removeItem(key);
};
